import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useGeneral } from '../../../contexts';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const { language } = useGeneral();
  const { getTranslation } = language;
  const [imageLoading, setImageLoading] = useState(true);
  
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.section}>
            <div className={styles.logo}>
              {imageLoading && <div className="image-shimmer" style={{ position: 'absolute', width: '32px', height: '32px', borderRadius: '4px' }} />}
              <img 
                src="/lodos-favicon.png" 
                alt="Lodos" 
                className={styles.logoImage}
                onLoad={() => setImageLoading(false)}
                onError={() => setImageLoading(false)}
              />
              <h3 className={styles.title}>ToGather</h3>
            </div>
            <p className={styles.description}>
              {getTranslation('footer.description')}
            </p>
          </div>
          
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>{getTranslation('footer.discover')}</h4>
            <ul className={styles.links}>
              <li>
                <Link to="/events" className={styles.link}>{getTranslation('navigation.events')}</Link>
              </li>
              <li>
                <Link to="/" className={styles.link}>{getTranslation('footer.discover')}</Link>
              </li>
            </ul>
          </div>
          
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>{getTranslation('footer.account')}</h4>
            <ul className={styles.links}>
              <li>
                <Link to="/login" className={styles.link}>{getTranslation('auth.login')}</Link>
              </li>
              <li>
                <Link to="/register" className={styles.link}>{getTranslation('auth.register')}</Link>
              </li>
            </ul>
          </div>
          
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>{getTranslation('footer.support')}</h4>
            <ul className={styles.links}>
              <li>
                <a href="https://lodos.io/faq" target="_blank" rel="noopener noreferrer" className={styles.link}>{getTranslation('footer.helpCenter')}</a>
              </li>
              <li>
                <a href="https://lodos.io/contact" target="_blank" rel="noopener noreferrer" className={styles.link}>{getTranslation('footer.contact')}</a>
              </li>
              <li>
                <a href="https://lodos.io/privacy-policy" target="_blank" rel="noopener noreferrer" className={styles.link}>{getTranslation('footer.privacyPolicy')}</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className={styles.bottom}>
          <p className={styles.copyright}>
            {getTranslation('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

